import axios from 'axios';
import { format, parseISO } from 'date-fns';

const baseURL = process.env.REACT_APP_BACKEND_API_URL || '';

const LIST_POPULATE =
  'populate[cover]=true&populate[photos][populate]=image';
const DETAIL_POPULATE =
  `${LIST_POPULATE}&populate[extraSections]=true`;

export function formatDateLabel(date) {
  if (!date) return '';
  try {
    return format(parseISO(date), 'MMMM yyyy');
  } catch {
    return '';
  }
}

export function resolveMediaUrl(url, apiBase = baseURL) {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${apiBase}${url}`;
}

function unwrap(entry) {
  if (!entry) return null;
  return entry.attributes ? { id: entry.id, ...entry.attributes } : entry;
}

function mediaUrl(media, apiBase) {
  const file = unwrap(media);
  return resolveMediaUrl(file?.url, apiBase);
}

export function mapPhoto(photo, apiBase, albumTitle) {
  const row = unwrap(photo) || {};
  const image = unwrap(row.image);
  const title = row.title || '';
  const caption = row.caption || '';
  const alt = row.alt || title || albumTitle || '';
  return {
    src: mediaUrl(image, apiBase),
    alt,
    caption: title,
    description: caption,
  };
}

export function mapMediaGallery(entry, apiBase = baseURL) {
  const row = unwrap(entry) || {};
  const title = row.title || '';
  const photos = (row.photos || []).map((photo) => mapPhoto(photo, apiBase, title));
  const cover = unwrap(row.cover);
  const coverImage = mediaUrl(cover, apiBase) || photos[0]?.src || '';
  const coverAlt = cover?.alternativeText || photos[0]?.alt || title;
  const extraSections = row.extraSections || [];

  return {
    slug: row.slug || '',
    title,
    date: row.date || '',
    dateLabel: formatDateLabel(row.date),
    description: row.cardDescription || '',
    intro: row.intro || '',
    coverImage,
    coverAlt,
    images: photos.filter((photo) => photo.src),
    sections: extraSections.map((section) => {
      const item = unwrap(section) || {};
      return {
        heading: item.heading || '',
        body: item.body || '',
      };
    }),
  };
}

export async function fetchMediaGalleries() {
  const res = await axios.get(
    `${baseURL}/api/media-galleries?sort=date:desc&${LIST_POPULATE}&pagination[pageSize]=1000`
  );
  const rows = res.data?.data || [];
  return rows.map((row) => mapMediaGallery(row, baseURL));
}

export async function fetchMediaGalleryBySlug(slug) {
  const res = await axios.get(
    `${baseURL}/api/media-galleries?filters[slug][$eq]=${encodeURIComponent(
      slug
    )}&${DETAIL_POPULATE}&pagination[pageSize]=1000`
  );
  const row = res.data?.data?.[0];
  return row ? mapMediaGallery(row, baseURL) : null;
}
